<template lang="pug">
.d-flex.justify-space-between.full-width.gap-16
  expand-menu(
    v-model="openMenu"
    :type="MENU_TYPES.INDEPEND"
    additional-menu-classes="redesign redesign-box-shadow mt-0 rounded-8 fixed"
    :close-on-click="false"
    :close-on-content-click="false"
  )
    template(#activator="{ on, attrs, value }")
      v-sheet.d-flex(
        color="transparent"
        width="100%"
        v-bind="attrs"
      )
        app-text-input(
          v-model="searchName"
          placeholder="Найти мероприятие"
          width="100%"
          color="redesignPrimary"
          @click.stop.prevent="openMenuMethod"
        )
    v-list
      v-list-item(v-if="loading")
        v-list-item-content
          v-list-item-title
            text-loader(text="..." :is-init="false")
      template(v-else-if="events.length")
        v-list-item(v-if="popularEvents.length && !foundEvents.length")
          v-list-item-content
            v-list-item-title
              .body-1.redesignSecondary--text Популярные мероприятия
              hr.mt-2.opacity-10
        v-list-item(
          v-for="event in events"
          :key="event.id"
          :to="`/event/view/${event.id}`"
        )
          v-list-item-content
            v-list-item-title {{ event.name }}
      v-list-item(v-else-if="!events.length && hasChangesInInput")
        v-list-item-content
          v-list-item-title
            .body-1.redesignSecondary--text Не найдено
  v-btn.body-1.weight-500.px-12.redesignControlsBackground--text.rounded-8(
    height="40px"
    color="redesignPrimary"
    full-height
    @click.stop.prevent="searchEventsHandler"
  ) Найти
  v-btn.rounded-8(
    fab
    depressed
    small
    to="/events-search"
    exact
  )
    v-icon(color="redesignPrimaryDarken") $ioptions
</template>

<script>
import ExpandMenu, { MENU_TYPES } from '../../ExpandMenu.vue';
import TextLoader from '../TextLoader.vue';
import AppButton from '../../controls/AppButton.vue';
import AppTextInput from '../../inputs/AppTextInput.vue';

export default {
  name: 'SearchEventField',

  components: {
    ExpandMenu,
    TextLoader,
    AppButton,
    AppTextInput,
  },

  data() {
    return {
      MENU_TYPES,

      openMenu: false,

      searchName: '',
      popularEvents: [],
      foundEvents: [],

      savedSearchName: null,

      loading: false,
    };
  },

  computed: {
    events() {
      return this.searchName ? this.foundEvents : this.popularEvents;
    },
    hasChangesInInput() {
      return this.searchName === this.savedSearchName;
    },
  },

  watch: {
    searchName(val) {
      if (!val) {
        this.foundEvents = [];
        this.savedSearchName = null;
      }
    },
  },

  mounted() {
    document.addEventListener('click', this.checkClickContent);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.checkClickContent);
  },

  methods: {
    checkClickContent() {
      this.openMenu = false;
    },
    async getPopularEvents() {
      this.loading = true;
      const params = {
        'per-page': 5,
        'search[add_distance]': 1,
        'search[status]': 1,
        sort: '-id',
      };

      const response = await this.$api.eventsPublic.getSearchEvents(params);

      this.popularEvents = response.data.data.map(({ id, name }) => ({ id, name }));
      this.loading = false;
      this.openMenu = true;
    },

    openMenuMethod() {
      this.openMenu = true;
      if (!this.popularEvents.length) {
        this.getPopularEvents();
      }
    },

    async searchEventsHandler() {
      this.openMenu = true;
      this.loading = true;
      if (this.searchName) {
        const params = {
          'per-page': 5,
          'search[name]': this.searchName,
          'search[add_distance]': 1,
          'search[status]': 1,
          sort: '-id',
        };

        const response = await this.$api.eventsPublic.getSearchEvents(params);

        this.foundEvents = response.data.data.map(({ id, name }) => ({ id, name }));

        this.savedSearchName = this.searchName;
      }
      this.loading = false;
      this.openMenu = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.search_field {
  margin: 0px !important;
  width: 100%;
}
</style>
